import { http } from '../api';
import { Filters, PaginateResponse } from '../model';
import { CreateJobRequest, Job } from '../model/Job';

const controller = 'jobs';

export async function getPaginate(filters?: Filters): Promise<PaginateResponse<Job>> {
  const params: Record<string, string> = {};
  if (filters?.name) {
    params['name'] = filters?.name;
  }
  const { data } = await http.get<PaginateResponse<Job> | any>(`${controller}/`, {
    params,
  });

    return  { page: data.page, total: data.total ? data.total : data.length , data: data.data ? data.data : data, limit: data.limit ? data.limit : '', totalPages: data.totalPages ? data.totalPages : '' };

}

export async function getBy(id: string): Promise<Job> {
  const { data } = await http.get<Job>(`${controller}/${id}`);
  return data;
}

export async function create(payload: CreateJobRequest): Promise<Job> {
  const { data } = await http.post<Job>(`${controller}/`, payload);
  return data;
}

export async function update(id: string, payload: CreateJobRequest): Promise<Job> {
  const { data } = await http.put<Job>(`${controller}/${id}`, { ...payload, id });
  return data;
}

export async function deleted(id: string): Promise<boolean> {
  const { status } = await http.delete(`${controller}/${id}`);
  return status === 204;
}
